export default {
  "formstepform.basic.title": "基礎表單",
  "formstepform.basic.description": "表單頁用於向用戶收集或驗證信息，基礎表單常見於數據項較少的表單場景。",
  "formstepform.email.required": "請輸入郵箱地址！",
  "formstepform.email.wrong-format": "郵箱地址格式錯誤！",
  "formstepform.userName.required": "請輸入賬戶!",
  "formstepform.password.required": "請輸入密碼！",
  "formstepform.password.twice": "兩次輸入的密碼不匹配!",
  "formstepform.strength.msg": "請至少輸入 6 個字符。請不要使用容易被猜到的密碼。",
  "formstepform.strength.strong": "強度：強",
  "formstepform.strength.medium": "強度：中",
  "formstepform.strength.short": "強度：太短",
  "formstepform.confirm-password.required": "請確認密碼！",
  "formstepform.phone-number.required": "請輸入手機號！",
  "formstepform.phone-number.wrong-format": "手機號格式錯誤！",
  "formstepform.verification-code.required": "請輸入驗證碼！",
  "formstepform.title.required": "請輸入標題",
  "formstepform.date.required": "請選擇起止日期",
  "formstepform.goal.required": "請輸入目標描述",
  "formstepform.standard.required": "請輸入衡量標淮",
  "formstepform.form.get-captcha": "獲取驗證碼",
  "formstepform.captcha.second": "秒",
  "formstepform.form.optional": "（選填）",
  "formstepform.form.submit": "提交",
  "formstepform.form.save": "保存",
  "formstepform.email.placeholder": "郵箱",
  "formstepform.password.placeholder": "至少6位密碼，區分大小寫",
  "formstepform.confirm-password.placeholder": "確認密碼",
  "formstepform.phone-number.placeholder": "手機號",
  "formstepform.verification-code.placeholder": "驗證碼",
  "formstepform.title.label": "標題",
  "formstepform.title.placeholder": "給目標起個名字",
  "formstepform.date.label": "起止日期",
  "formstepform.placeholder.start": "開始日期",
  "formstepform.placeholder.end": "結束日期",
  "formstepform.goal.label": "目標描述",
  "formstepform.goal.placeholder": "請輸入妳的階段性工作目標",
  "formstepform.standard.label": "衡量標淮",
  "formstepform.standard.placeholder": "請輸入衡量標淮",
  "formstepform.client.label": "客戶",
  "formstepform.label.tooltip": "目標的服務對象",
  "formstepform.client.placeholder": "請描述妳服務的客戶，內部客戶直接 @姓名／工號",
  "formstepform.invites.label": "邀評人",
  "formstepform.invites.placeholder": "請直接 @姓名／工號，最多可邀請 5 人",
  "formstepform.weight.label": "權重",
  "formstepform.weight.placeholder": "請輸入",
  "formstepform.public.label": "目標公開",
  "formstepform.label.help": "客戶、邀評人默認被分享",
  "formstepform.radio.public": "公開",
  "formstepform.radio.partially-public": "部分公開",
  "formstepform.radio.private": "不公開",
  "formstepform.publicUsers.placeholder": "公開給",
  "formstepform.option.A": "同事甲",
  "formstepform.option.B": "同事乙",
  "formstepform.option.C": "同事丙",
};
